import ApiModel from "../APIModel";

export default class RSS extends ApiModel {
  constructor() {
    super("rss");
  }
}
